import React, { useEffect, useState } from 'react';
import ICO from '../assets/ico/charity.png'
import { FaCheck } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import Paypal from './Paypal';

const SettingIco = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [showProgress, setShowProgress] = useState(false);

    const [amount, setAmount] = useState(10)
    const [checkOut, setCheckOut] = useState(false)



    const handleIconClick = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    useEffect(() => {
        if (checkOut === false) {
            setShowProgress(false)
        }
    }, [checkOut])

    return (
        <div className='fixed bottom-12 right-0 p-2 sm:p-8 cursor-pointer group z-10 max-h-[600px] overflow-auto rounded-full' onMouseEnter={() => { setIsDropdownOpen(true); setShowProgress(true); }}
            onMouseLeave={() => {
                if (checkOut !== true) {
                    setIsDropdownOpen(false);
                    setShowProgress(false);
                    setCheckOut(false)
                }
            }}
        >
            <div
                onClick={handleIconClick}
                className={`bg-[#87ceeb] overflow-auto scrollable-div rounded-full p-2 flex items-center transition-max-w transition-max-w duration-[1500ms] ${showProgress ? 'w-[320px]' : 'w-[48px]'}  justify-between`}
            >
                <div className=''>
                    <span className={`font-bold italic underline hover:text-blue-500 px-4 ${isDropdownOpen && (checkOut === false || checkOut == null) ? 'flex flex-col' : 'hidden'}`} onClick={() => { setCheckOut(null) }}>Click to donate Today and save life !</span>

                    <div className={`${checkOut === null ? 'flex flex-col p-1' : 'hidden'}`}>
                        <label htmlFor="amount">Amount: USD </label>
                        <div className='flex flex-row items-center gap-2'>
                            <input
                                type="number"
                                id="amount"
                                name="amount"
                                value={amount}
                                className="border rounded-md w-fit p-1"
                                onChange={(e) => setAmount(e.target.value)}
                            />
                            <div className="bg-green-500 text-white p-2 rounded cursor-pointer hover:opacity-75 w-fit" onClick={() => { setCheckOut(true) }}><FaCheck /></div>
                            <div className="bg-red-500 text-white p-2 rounded cursor-pointer hover:opacity-75 w-fit" onClick={() => { setCheckOut(false) }}><MdClose /></div>
                        </div>
                    </div>

                    {checkOut === true &&
                        <div className='flex flex-col '>
                            {/* <span className='pb-10 mt-10 mb-10 h-96 bg-transparent'></span> */}
                            <Paypal setCheckOut={setCheckOut} amount={amount} />
                        </div>
                    }
                </div>
                <img src={ICO} alt={'ICO'} sizes={40} className='animate-bounce' />
            </div>
        </div >
    );
};


export default SettingIco;
